import React, { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import Navbar from '../../../../components/navbar';
import Footer from '../../../../components/footer';
import Button from '../../../../components/Button';
import Checkbox from '../../../../components/Checkbox';
import { useConsultation } from '../../../../context/ConsultationContext';
import { handleTreatmentServiceNavigation } from '../components/treatmentNavigationHelper';
import baseStyles from './css/BloodPressure.module.css';
import styles from './css/PeakFlow.module.css';
import { Wind, Send } from 'lucide-react';

const PeakFlow = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const { consultationData, updateConsultationData, getStepDraft, setStepDraft, goToStep } = useConsultation();

    const patient = location?.state?.patient || consultationData?.patient || {};
    const patientName = `${patient?.firstname || ""} ${patient?.surname || ""}`.trim() || "Thandiwe Ndlovu";
    const profileNumber = patient?.profilenumber || "448896";
    const initials = `${patient?.firstname?.[0] || ""}${patient?.surname?.[0] || ""}`.toUpperCase() || "TN";

    const [peakFlowReading, setPeakFlowReading] = useState('');
    const [personalBest, setPersonalBest] = useState('');
    const [asthmaHistory, setAsthmaHistory] = useState(false);
    const [clinicalNotes, setClinicalNotes] = useState('');

    useEffect(() => {
        document.body.classList.add(baseStyles.hideSidebar);
        return () => {
            document.body.classList.remove(baseStyles.hideSidebar);
        };
    }, []);

    const handleInvoice = () => {
        handleTreatmentServiceNavigation({
            location,
            navigate,
            consultationData,
            updateConsultationData,
            getStepDraft,
            setStepDraft,
            goToStep,
            serviceData: {
                peak_flow: {
                    peakFlowReading,
                    personalBest,
                    asthmaHistory,
                    clinicalNotes,
                },
            },
        });
    };

    return (
        <div className={baseStyles.bloodPressureContainer}>
            <Navbar />

            <main className={baseStyles.mainContent}>
                <div className={baseStyles.card}>
                    <div className={baseStyles.cardHeader}>
                        <div className={baseStyles.headerIcon} aria-hidden="true">
                            <Wind />
                        </div>
                        <h1 className={styles.title}>Peak Flow Test</h1>
                    </div>

                    <div className={baseStyles.patientCard}>
                        <div className={baseStyles.avatar} aria-hidden="true">{initials}</div>
                        <div className={baseStyles.patientText}>
                            <div className={baseStyles.patientName}>{patientName}</div>
                            <div className={baseStyles.patientMetaRow}>
                                <span className={baseStyles.profileInfo}>Profile: {profileNumber}</span>
                                <span className={baseStyles.dependentBadge}>Dependent</span>
                            </div>
                        </div>
                    </div>

                    <div className={baseStyles.sectionBlock}>
                        <div className={baseStyles.sectionTitle}>READINGS</div>

                        <div className={styles.readingsRow}>
                            <div className={baseStyles.readingItem}>
                                <label className={baseStyles.readingLabel}>Peak Flow Reading</label>
                                <div className={baseStyles.inputGroup}>
                                    <input
                                        type="number"
                                        value={peakFlowReading}
                                        onChange={(e) => setPeakFlowReading(e.target.value)}
                                        className={baseStyles.readingInput}
                                        placeholder="—"
                                    />
                                    <span className={baseStyles.unit}>L/min</span>
                                </div>
                            </div>

                            <div className={baseStyles.readingItem}>
                                <label className={baseStyles.readingLabel}>Personal Best(if known)</label>
                                <div className={baseStyles.inputGroup}>
                                    <input
                                        type="number"
                                        value={personalBest}
                                        onChange={(e) => setPersonalBest(e.target.value)}
                                        className={baseStyles.readingInput}
                                        placeholder="—"
                                    />
                                    <span className={baseStyles.unit}>L/min</span>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className={baseStyles.sectionBlock}>
                        <div className={baseStyles.sectionTitle}>HISTORY</div>

                        <div className={styles.toggleSectionHistory}>
                            <label className={baseStyles.toggleLabel}>Asthma history</label>
                            <button
                                type="button"
                                className={`${baseStyles.toggleButton} ${asthmaHistory ? baseStyles.active : ''}`}
                                onClick={() => setAsthmaHistory(!asthmaHistory)}
                                aria-pressed={asthmaHistory}
                            >
                                <div className={baseStyles.toggleSlider}></div>
                            </button>
                        </div>
                    </div>

                    <div className={baseStyles.sectionBlock}>
                        <div className={baseStyles.fieldLabel}>Clinical Notes</div>
                        <textarea
                            value={clinicalNotes}
                            onChange={(e) => setClinicalNotes(e.target.value)}
                            className={baseStyles.clinicalNotes}
                            placeholder="Enter clinical notes..."
                            rows={6}
                        />
                    </div>

                    <div className={baseStyles.cardFooter}>
                        <Button
                            onClick={handleInvoice}
                            className={baseStyles.invoiceButton}
                            type="button"
                        >
                            <Send size={16} />
                            Invoice
                        </Button>
                    </div>
                </div>
            </main>

            <Footer />
        </div>
    );
};

export default PeakFlow;